var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"calendar-cell h-5/6base w-5/6base flex items-center justify-center text-sm whitespace-no-wrap",class:_vm.rootClasses},[_c('span',[_vm._v(_vm._s(_vm.date.day))])])}
var staticRenderFns = []

export { render, staticRenderFns }